"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListOrderType = exports.BoundType = exports.MultisigTransactionState = exports.NetworkAttributes = exports.AccountInfoPayloadResponseLabels = exports.AccountRole = exports.AccountMultisigArgument = exports.AccountFeatureTypes = exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["send"] = "send";
    EventType["accountCreate"] = "accountCreate";
    EventType["accountSetDescription"] = "accountSetDescription";
    EventType["accountDisable"] = "accountDisable";
    EventType["accountAddFeatures"] = "accountAddFeatures";
    EventType["accountAddRoles"] = "accountAddRoles";
    EventType["accountRemoveRoles"] = "accountRemoveRoles";
    EventType["accountMultisigSubmit"] = "accountMultisigSubmit";
    EventType["accountMultisigApprove"] = "accountMultisigApprove";
    EventType["accountMultisigRevoke"] = "accountMultisigRevoke";
    EventType["accountMultisigExecute"] = "accountMultisigExecute";
    EventType["accountMultisigWithdraw"] = "accountMultisigWithdraw";
    EventType["accountMultisigSetDefaults"] = "accountMultisigSetDefaults";
    EventType["accountMultisigExpired"] = "accountMultisigExpired";
    EventType["mint"] = "mint";
    EventType["burn"] = "burn";
})(EventType = exports.EventType || (exports.EventType = {}));
var AccountFeatureTypes;
(function (AccountFeatureTypes) {
    /**
     * adds canLedgerTransact account role
     */
    AccountFeatureTypes[AccountFeatureTypes["accountLedger"] = 0] = "accountLedger";
    /**
     * adds canMultisigSubmit and canMultisigApprove roles
     */
    AccountFeatureTypes[AccountFeatureTypes["accountMultisig"] = 1] = "accountMultisig";
})(AccountFeatureTypes = exports.AccountFeatureTypes || (exports.AccountFeatureTypes = {}));
var AccountMultisigArgument;
(function (AccountMultisigArgument) {
    AccountMultisigArgument[AccountMultisigArgument["threshold"] = 0] = "threshold";
    AccountMultisigArgument[AccountMultisigArgument["expireInSecs"] = 1] = "expireInSecs";
    AccountMultisigArgument[AccountMultisigArgument["executeAutomatically"] = 2] = "executeAutomatically";
})(AccountMultisigArgument = exports.AccountMultisigArgument || (exports.AccountMultisigArgument = {}));
var AccountRole;
(function (AccountRole) {
    AccountRole[AccountRole["owner"] = 0] = "owner";
    AccountRole[AccountRole["canLedgerTransact"] = 1] = "canLedgerTransact";
    AccountRole[AccountRole["canMultisigApprove"] = 2] = "canMultisigApprove";
    AccountRole[AccountRole["canMultisigSubmit"] = 3] = "canMultisigSubmit";
})(AccountRole = exports.AccountRole || (exports.AccountRole = {}));
var AccountInfoPayloadResponseLabels;
(function (AccountInfoPayloadResponseLabels) {
    AccountInfoPayloadResponseLabels[AccountInfoPayloadResponseLabels["name"] = 0] = "name";
    AccountInfoPayloadResponseLabels[AccountInfoPayloadResponseLabels["roles"] = 1] = "roles";
    AccountInfoPayloadResponseLabels[AccountInfoPayloadResponseLabels["features"] = 2] = "features";
})(AccountInfoPayloadResponseLabels = exports.AccountInfoPayloadResponseLabels || (exports.AccountInfoPayloadResponseLabels = {}));
var NetworkAttributes;
(function (NetworkAttributes) {
    NetworkAttributes[NetworkAttributes["base"] = 0] = "base";
    NetworkAttributes[NetworkAttributes["blockchain"] = 1] = "blockchain";
    NetworkAttributes[NetworkAttributes["ledger"] = 2] = "ledger";
    NetworkAttributes[NetworkAttributes["kvstore"] = 3] = "kvstore";
    NetworkAttributes[NetworkAttributes["events"] = 4] = "events";
    NetworkAttributes[NetworkAttributes["ledgerCommands"] = 6] = "ledgerCommands";
    NetworkAttributes[NetworkAttributes["kvstoreCommands"] = 7] = "kvstoreCommands";
    NetworkAttributes[NetworkAttributes["async"] = 8] = "async";
    NetworkAttributes[NetworkAttributes["account"] = 9] = "account";
    NetworkAttributes[NetworkAttributes["idstore"] = 1002] = "idstore";
})(NetworkAttributes = exports.NetworkAttributes || (exports.NetworkAttributes = {}));
var MultisigTransactionState;
(function (MultisigTransactionState) {
    MultisigTransactionState[MultisigTransactionState["pending"] = 0] = "pending";
    MultisigTransactionState[MultisigTransactionState["executedAutomatically"] = 1] = "executedAutomatically";
    MultisigTransactionState[MultisigTransactionState["executedManually"] = 2] = "executedManually";
    MultisigTransactionState[MultisigTransactionState["withdrawn"] = 3] = "withdrawn";
    MultisigTransactionState[MultisigTransactionState["expired"] = 4] = "expired";
})(MultisigTransactionState = exports.MultisigTransactionState || (exports.MultisigTransactionState = {}));
var BoundType;
(function (BoundType) {
    BoundType["unbounded"] = "unbounded";
    BoundType["inclusive"] = "inclusive";
    BoundType["exclusive"] = "exclusive";
})(BoundType = exports.BoundType || (exports.BoundType = {}));
var ListOrderType;
(function (ListOrderType) {
    ListOrderType[ListOrderType["indeterminate"] = 0] = "indeterminate";
    ListOrderType[ListOrderType["ascending"] = 1] = "ascending";
    ListOrderType[ListOrderType["descending"] = 2] = "descending";
})(ListOrderType = exports.ListOrderType || (exports.ListOrderType = {}));
